import React from 'react';
import { DemeterTableDefinitionType, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IProjectionChartProps } from '../../../Components/Charts/Projection/ProjectionChart';
import { IRegionCommoditySelection } from '../../../Components/Navigation/Hooks/useRegionCommodityNavigationHook';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withMarginChartFromPageElement = (ProjectionChart: React.ComponentType<IProjectionChartProps>): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = (props) => {
        if (!props.pageElement) {
            return <> </>;
        }

        const { demeterPageElementGuid, region, subRegion, commodity, extraParameters, dataFrequency, unitOfMeasure } = props.pageElement;
        const [translations] = useLanguage();

        const pageTitle = translations.production.marginChart.title;
        const tableDefinitionType = DemeterTableDefinitionType.CommodityMonthlyMarginTable;

        const regionCommoditySelection = {
            region,
            subRegion,
            commodity,
            extraParameters: extraParameters && Object.keys(extraParameters).length > 0 ? JSON.stringify(extraParameters) : null,
            dataFrequency,
        } as IRegionCommoditySelection;

        const chartProps: IProjectionChartProps = {
            title: pageTitle,
            customTitle: props.customTitle,
            tableDefinitionType,
            regionCommoditySelection,
            aggregateRegions: [],
            unitOfMeasure: unitOfMeasure ?? UnitOfMeasure.MetricTon,
            testId: `dashboard-margin-chart-${demeterPageElementGuid}`,
            dragIndicatorIcon: props.dragIndicatorIcon,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            maxWidthHeightRatio: props.maxWidthHeightRatio,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
            track: {
                eventCategory: 'Dashboard',
                eventAction: 'ProjectionChart',
                eventValue: { tableDefinitionType, regionCommoditySelection },
            },
        };

        return <ProjectionChart {...chartProps} />;
    };

    return Wrapped;
};

export default withMarginChartFromPageElement;
